import styled from 'styled-components'

export const Title = styled.h1`
  text-align: center;
`

export const StatusText = styled.p`
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
`

export const Container = styled.div`
  padding: 0rem 2rem 2rem;
  .page-body {
    background-color: #F5F5F5 !important;
  }
`

export const Button = styled.button`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
  font-size: 14px;
`

export const ButtonReset = styled.button`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
  font-size: 14px;
  width: 15rem;
  margin-top: 2rem;
`

export const ContainerReset = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WrongProductsWrapper = styled.div`
  margin-top: 3.5rem;
`

export const SubTitle = styled.span`
  margin-bottom: 0;
  font-size: 1.5rem;
  font-weight: 700;
  font-family: Work Sans;
`

export const SubTitleExtension = styled(SubTitle)`
  font-weight: 400;
  color: #3B3B3B;
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
`

export const ContainerInfo = styled.div`
  display: flex;
  align-items: start;
  flex-wrap: wrap;
  gap: 2rem;
`
